import { useGetOpenPaymentsSuggestionsV2Query } from 'src/api/redux';

interface UseGetOpenPaymentsSuggestionsV2Params {
  q: string;
}

/**
 * Hook to fetch open payments suggestions using RTK Query
 */
const useGetOpenPaymentsSuggestionsV2 = (
  params: UseGetOpenPaymentsSuggestionsV2Params
) => {
  const { data, error, isLoading } = useGetOpenPaymentsSuggestionsV2Query(
    { q: params.q },
    {
      skip: !params.q,
    }
  );

  return {
    data,
    error,
    isLoading,
  };
};

export default useGetOpenPaymentsSuggestionsV2;
